/* eslint-disable */

import axios from 'axios';
import CryptoService from "@/services//crypto-services";
import store from '@/store';
import { ModuleConfigurationRequest } from '@/Types/ModuleConfigurationRequest';



//"http://localhost:62853";
// const remoteURL="https://agenthealth.greenstonesystems.com/AgentManagementService"
const loggerRemoteURL = process.env.NODE_ENV === 'production' ? "/Logging" : "http://localhost:44383";
// const loggerRemoteURL = "https://agenthealth.greenstonesystems.com/Logging";
const configUrl = "https://configfarm.greenstonesystems.com";
const configRemoteKey = 'YWRtaW46cGFzc3dvcmQx';
const gatewayURL = `https://gateway.greenstonesystems.com`;

export default class DataService {
    remoteURL = '';
    constructor() {
        // this.remoteURL = process.env.NODE_ENV === 'production' ? this.getGatewayUrl() : this.getGatewayUrl();
    }

    getGatewayUrl() {
        if (process.env.NODE_ENV === 'production') {
            if (store.getters.getGateway === 'Production') {
                return '/AgentManagementService';
            } else {
                return 'https://gatewayctd.greenstonesystems.com/AgentManagementService';
            }
        } {
            if (store.getters.getGateway === 'Production') {
                return 'http://localhost:62853'; //http://localhost:62853
            } else {
                return 'http://localhost:62853'; //http://localhost:62853
            }
        }

    }

    getConfigUrl() {
        if (process.env.NODE_ENV === 'production') {
            if (store.getters.getGateway === 'Production') {
                return 'https://configfarm.greenstonesystems.com';
            } else {
                return 'https://configfarmctd.greenstonesystems.com';
            }
        } {
            if (store.getters.getGateway === 'Production') {
                return 'https://configfarm.greenstonesystems.com'; //http://localhost:62853
            } else {
                return 'https://configfarmctd.greenstonesystems.com'; //http://localhost:62853
            }
        }
    }

    getLoggerRemoteUrl() {
        if (process.env.NODE_ENV === 'production') {
            if (store.getters.getGateway === 'Production') {
                return '/Logging';
            } else {
                return 'https://agenthealth.greenstonesystems.com/Logging';
            }
        } {
            if (store.getters.getGateway === 'Production') {
                return 'https://agenthealth.greenstonesystems.com/Logging';
            } else {
                return 'https://agenthealth.greenstonesystems.com/Logging';
            }
        }
    }

    getFile(session: string, filePath: string, fileName: string): Promise<Blob> {
        var p = new Promise<Blob>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/AgentFile?AgentSessionId=${session}&Path=${filePath}`, { 'responseType': 'arraybuffer' })
                .then((response) => {
                    resolve(new Blob([response.data]));
                })
                .catch((error) => {
                    reject(error);
                });
        })
        return p;
    }
    SyncAgentsWithGateway(): Promise<void> {
        var p = new Promise<void>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/AutoUpdate/SyncAgentsWithGateway`).then(() => {
                resolve()
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    UploadFile(data: any, agentId: number): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/UploadFile/${agentId}`, data).then((response) => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    executeMetaUtil(agentid: number, command: string): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/RunMetaUtil/${agentid}?command=${command}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    DatabaseQuery(agentid: number, tenantcode: string, command: string): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/DbQueryCommand/${agentid}?TenantCode=${tenantcode}&Command=${encodeURIComponent(command)}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    getDatasets(agentid: number): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/GetDatasets/${agentid}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    logFiles(agentid: number): Promise<Array<string>> {
        var p = new Promise<Array<string>>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/LogFiles/${agentid}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    logFile(agentid: number, path: string): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/LogFile/${agentid}?path=${encodeURIComponent(path)}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    RefreshAllAgents(): Promise<void> {
        var p = new Promise<void>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/SyncAllAgentInfos`).then(() => {
                resolve()
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    CheckOnlineStatus(agentid: number): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/CheckOnlineStatus/${agentid}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    getAgentList(): Promise<Array<any>> {
        var p = new Promise<Array<any>>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Agent`).then(response => {
                for (var i = 0; i < response.data.length; i++) {
                    var defaultObj = { Files: [], Settings: {}, Agris: {} };
                    try {
                        response.data[i].InfoJSON = JSON.parse(response.data[i].Info) || defaultObj;
                    } catch (err) {
                        console.log(i, response.data[i].Info, err);
                        response.data[i].InfoJSON = defaultObj;
                    }
                }
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    getAgent(agentid: number): Promise<any> {
        var p = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Agent/${agentid}`).then(response => {
                var defaultObj = { Files: [], Settings: {}, Agris: {} };
                try {
                    response.data.InfoJSON = JSON.parse(response.data.Info) || defaultObj;
                } catch (err) {
                    console.log(response.data.Info, err);
                    response.data.InfoJSON = defaultObj;
                }
                resolve(response.data)
            }).catch(e => {
                reject(e);
            });
        });
        return p;
    }
    createAgent(agent): Promise<number> {
        var p = new Promise<number>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/Agent`, agent)
                .then(response => {
                    resolve(response.data)
                }).catch(e => {
                    reject(e);
                });
        });
        return p;
    }
    updateAgent(agent): Promise<void> {
        var p = new Promise<void>((resolve, reject) => {
            this.putWithAuth(`${this.getGatewayUrl()}/api/Agent`, agent).then(response => {
                resolve()
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    syncAgent(AgentId: number): Promise<void> {
        var p = new Promise<void>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/SyncAgentInfoById/${AgentId}`).then(response => {
                resolve()
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    AutoUpdateAgent(AgentId: number, Release: any): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/AutoUpdate/Update/${AgentId}`, Release).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    ReConnectAgentToGateway(sessionID: string) {
        let headers = {};
        headers["SessionID"] = sessionID;
        let body = {};
        body["Command"] = "Modularis.ConnectToGateway|CulturaHub (gateway.greenstonesystems.com)";
        body["Options"] = null;
        body["SessionID"] = sessionID;
        body["CustomerID"] = "C93F949C-41B8-4C9E-95AA-B030B31F6F3F";
        return this.post(`${gatewayURL}/Culturahub/RESTCommandWebService/ExecuteCommand`, body, headers);

    }
    getReleases(): Promise<Array<any>> {
        var p = new Promise<Array<any>>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Release`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    approveReleases(release: any): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/Release`, release).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    CanAgentSetup(AgentId: number): Promise<Array<string>> {
        var p = new Promise<Array<string>>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/AutoUpdate/CanAgentSetup/${AgentId}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    SetupAgentAutoUpdate(AgentId: number): Promise<Array<string>> {
        var p = new Promise<Array<string>>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/AutoUpdate/SetupAgentAutoUpdate/${AgentId}`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    ForceRestartAgent(AgentId: number): Promise<void> {
        var p = new Promise<void>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/AutoUpdate/ForceRestart/${AgentId}`).then(response => {
                resolve()
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }

    getUsers(): Promise<any> {
        var p = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/User`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    getUsersWithRoles(): Promise<any> {
        var p = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/User/getWithRoles`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    createUser(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/User`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('User not created, something went wrong');
                    }
                });
        });
        return p;
    }
    editUser(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.putWithAuth(`${this.getGatewayUrl()}/api/User`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('User not created, something went wrong');
                    }
                });
        });
        return p;
    }
    deleteUser(user): Promise<boolean> {
        var p = new Promise<boolean>((resolve, reject) => {
            this.deleteWithAuth(`${this.getGatewayUrl()}/api/User`, user)
                .then(response => {
                    resolve(true)
                }).catch(e => {
                    reject(e);
                });
        });
        return p;
    }
    getPermissions(): Promise<any> {
        var p = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Role/GetPermissions`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    getRoles(): Promise<any> {
        var p = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Role`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    getRolesWithPermissions(): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Role/getWithPermissions`).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e);
            })
        });
        return p;
    }
    createRole(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/Role`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('Role not created, something went wrong');
                    }
                });
        });
        return p;
    }
    editRole(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.putWithAuth(`${this.getGatewayUrl()}/api/Role`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('Role not created, something went wrong');
                    }
                });
        });
        return p;
    }
    deleteRole(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.deleteWithAuth(`${this.getGatewayUrl()}/api/Role`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    debugger
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('Role not deleted, something went wrong');
                    }
                });
        });
        return p;
    }

    login(userEmail, password): Promise<any> {
        return axios({
            method: 'post',
            url: `${this.getGatewayUrl()}/token`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            data: `grant_type=password&username=${userEmail}&password=${password}`
        });
    }

    logout(): Promise<boolean> {
        var promise = new Promise<boolean>((resolve, reject) => {
            this.postWithAuth(`${this.getGatewayUrl()}/api/User/Logout`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
    changePassword(user): Promise<string> {
        var p = new Promise<string>((resolve, reject) => {
            this.putWithAuth(`${this.getGatewayUrl()}/api/User/ChangePassword`, user)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    if (e.response && e.response.status === 412) {
                        reject(e.response.data.Message);
                    } else {
                        reject('Password not changed, something went wrong');
                    }
                });
        });
        return p;
    }

    getUser(authToken): Promise<any> {
        return axios({
            method: 'get',
            url: `${this.getGatewayUrl()}/api/User/userinfo`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authToken,
            },
        });
    }

    getAudit(): Promise<any> {
        var req = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Audit`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
        return req;
    }
    searchAudit(userName: string, entity: string, action: string, field: string, date: string): Promise<any> {
        date = date === null ? "" : date;
        var req = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/Audit/search?userName=${userName}&entity=${entity}&action=${action}&field=${field}&date=${date}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
        return req;
    }

    FetchAgentEvents(logType: string, agentID: number, dateFrom: string, dateTo: string): Promise<any> {
        if (logType) {
            logType = logType === 'Info' ? 'Information' : logType;
        } else logType = '';
        agentID = agentID ? agentID : null
        dateFrom = dateFrom ? dateFrom : ''
        dateTo = dateTo ? dateTo : ''
        var req = new Promise<any>((resolve, reject) => {
            this.getWithAuth(`${this.getGatewayUrl()}/api/DeployedAgent/FetchAgentEvents?logType=${logType}&id=${agentID}&dateFrom=${dateFrom}&dateTo=${dateTo}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
        return req;
    }

    //General request methods
    getWithAuth(url: any, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = store.getters.getIsAuthenticated ? `Bearer ${store.getters.getAuthToken}` : null;
        return axios({
            method: 'get',
            url,
            headers: header,
        });
    }

    postWithAuth(url: any, postdata = null, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = store.getters.getIsAuthenticated ? `Bearer ${store.getters.getAuthToken}` : null;
        return axios({
            method: 'post',
            url,
            data: postdata,
            headers: header,
        });
    }

    putWithAuth(url: any, postdata = null, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = store.getters.getIsAuthenticated ? `Bearer ${store.getters.getAuthToken}` : null;
        return axios({
            method: 'put',
            url,
            data: postdata,
            headers: header,
        });
    }

    deleteWithAuth(url: any, postdata = null, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = store.getters.getIsAuthenticated ? `Bearer ${store.getters.getAuthToken}` : null;
        return axios({
            method: 'delete',
            url,
            data: postdata,
            headers: header,
        });
    }

    // Config Service Method
    getConfigModules(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.getFromConfigServer(`${this.getConfigUrl()}/api/Modules`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    getConfigKeys(moduleId: Number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.getFromConfigServer(`${this.getConfigUrl()}/api/ConfigurationKey?ModuleId=${moduleId}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    getModuleConfigs(moduleId: Number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.getFromConfigServer(`${this.getConfigUrl()}/api/ModuleConfigurations?ModuleId=${moduleId}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    postModuleConfigs(data: ModuleConfigurationRequest[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.postFromConfigServer(`${this.getConfigUrl()}/api/ModuleConfigurations`, data).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }

    getFromConfigServer(url: any, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = `Basic ${configRemoteKey}`;
        return axios({
            method: 'get',
            url,
            headers: header,
        });
    }

    postFromConfigServer(url: any, postdata = null, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        header['Authorization'] = `Basic ${configRemoteKey}`;
        return axios({
            method: 'post',
            url,
            data: postdata,
            headers: header,
        });
    }

    post(url: any, postdata = null, config = null) {
        const header = config || {};
        header['Content-Type'] = 'application/json';
        return axios({
            method: 'post',
            url,
            data: postdata,
            headers: header,
        });
    }
    getLogs(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            return axios({
                method: 'get',
                url: `${this.getLoggerRemoteUrl()}/api/logs/logs`
            }).then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response)
                }
            }).catch(e => {
                reject(e);
            });
        });
    }
}